import "../../_namespaces.js";
import "../../_generated_templates.js";
import "#vendor/modernizr.js";
import "../../scoring/sum.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.AssessmentIntro = class AssessmentIntro extends Backbone.View {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
  }

  render() {
    this.$el.html(this.template(this.model.attributes));
    return this;
  }
};
AssessmentViewer.Views.AssessmentIntro.prototype.tagName = "div";
AssessmentViewer.Views.AssessmentIntro.prototype.className = "assessment-view assessment-view--intro";
AssessmentViewer.Views.AssessmentIntro.prototype.template = _.template(AssessmentViewer.Templates.Assessment.intro);
